import {
  GET_NOTIFICATION_TEMPLATES,
  GET_NOTIFICATION_TEMPLATE_DETAIL,
  PREVIEW_NOTIFICATION_TEMPLATE,
  UPDATE_NOTIFICATION_TEMPLATE,
  GET_MODULE_TYPES,
} from "@/api/settings/notification-template";

const handleRequest = async (apiFunc, commit, mutation, args, emptyValue = []) => {
  try {
    const resp = await apiFunc(args);
    const { httpCode, data } = resp.data;

    if (httpCode === 200) {
      if (data?.data && data?.totalItems !== undefined) {
        commit(mutation, {
          data: data.data,
          total: data.totalItems,
          page: data.page,
          limit: data.limit,
          totalPages: data.totalPages,
        });
      } else {
        commit(mutation, data);
      }
      return data;
    }

    commit(mutation, emptyValue);
    return emptyValue;
  } catch (err) {
    const resp = err?.response?.data;
    if (resp?.httpCode === 404) {
      commit(mutation, emptyValue);
    }
    throw err;
  }
};

const state = {
  notificationTemplates: {
    data: [],
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 1,
  },
  notificationTemplateDetail: null,
};

const mutations = {
  setNotificationTemplates: (state, payload) => {
    state.notificationTemplates = {
      data: payload.data || [],
      total: payload.total || 0,
      page: payload.page || 1,
      limit: payload.limit || 10,
      totalPages: payload.totalPages || 1,
    };
  },
  setNotificationTemplateDetail: (state, payload) => (state.notificationTemplateDetail = payload),
};

const actions = {
  async getNotificationTemplates({ commit }, query) {
    return handleRequest(GET_NOTIFICATION_TEMPLATES, commit, "setNotificationTemplates", query, []);
  },

  async getNotificationTemplateDetail({ commit }, id) {
    return handleRequest(GET_NOTIFICATION_TEMPLATE_DETAIL, commit, "setNotificationTemplateDetail", id, null);
  },

  async updateNotificationTemplate(_, { id, data }) {
    return UPDATE_NOTIFICATION_TEMPLATE({ id, data });
  },

  async previewNotificationTemplate(_, { id, data }) {
    return PREVIEW_NOTIFICATION_TEMPLATE({ id, data });
  },

  async getModuleTypes(_) {
    const responses = await GET_MODULE_TYPES();

    return responses.data.data;
  },
};

const getters = {
  notificationTemplates: (state) => state.notificationTemplates,
  notificationTemplateDetail: (state) => state.notificationTemplateDetail,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
